import { SVGProps } from "react"
const FailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.671875" width="60" height="60" rx="30" fill="#FFE6E4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.0083 40.9679C44.7734 43.263 42.5899 45.4465 40.2948 44.6815L17.8384 37.196C15.337 36.3622 15.1175 32.9095 17.4931 31.7657L25.6045 27.8602C26.2961 27.5272 26.8541 26.9692 27.1871 26.2776L31.0925 18.1663C32.2364 15.7907 35.6891 16.0101 36.5229 18.5115L44.0083 40.9679ZM41.0089 42.5391C41.5386 42.7156 42.0424 42.2117 41.8659 41.6821L34.3804 19.2257C34.188 18.6484 33.3912 18.5978 33.1273 19.146L29.2219 27.2573C29.1108 27.4879 28.9848 27.7096 28.8449 27.9212L35.0921 34.1684C35.5331 34.6094 35.5331 35.3244 35.0921 35.7653C34.6511 36.2063 33.9362 36.2063 33.4952 35.7653L27.248 29.5181C27.0365 29.6579 26.8148 29.7839 26.5842 29.8949L18.4728 33.8004C17.9246 34.0644 17.9753 34.8612 18.5525 35.0536L41.0089 42.5391Z"
      fill="#C92418"
    />
  </svg>
)
export default FailIcon
